import {Grid, Stack, Typography, useMediaQuery} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {GeneralInfoBase} from '../../components/formsBase/generalBase';
import {TermsOfServiceContent} from './termsOfServiceContent';

/**
 * React functional component representing the Terms of Service Page.
 * @component
 * @returns {JSX.Element} The rendered TermsOfServicePage component.
 */
export const TermsOfServicePage = () => {
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  return (
    <GeneralInfoBase>
      <Stack alignItems="center" sx={{ml: 1.3, mr: 3}}>
        <Typography variant="h4" textAlign="center" sx={{fontSize: isSmallScreen ? '20px' : '24px'}}>
          TERMS OF SERVICE AGREEMENT
        </Typography>
        <Grid container maxWidth={1000} spacing={2} sx={{m: 2}} justifyContent="center">
          <Grid item xs={12} md={11}>
            <TermsOfServiceContent isPage={true} />
          </Grid>
        </Grid>
      </Stack>
    </GeneralInfoBase>
  );
};
